import {
  CommonPageResponse,
  CommonResponse,
} from "./commonInterface.interface";

export interface FeaturesPopupData {
  id?: string;
  title: string;
  startDate: string;
  endDate: string;
  slides: {
    title: string;
    description: string;
    fileName?: string;
    url?: string;
    slideOrder: number;
    id?: string;
  }[];
  isActive: boolean;
  deleted?: string[];
  isClear?: boolean;
  isLive?: boolean;
  isRead?: boolean;
}

export interface FeaturesPopupListData extends FeaturesPopupData {
  createdBy: string;
  createdAt: string;
  isLive: boolean;
  isClear: boolean;
}

export interface FirmwareAliveStatusRequest {
  recorderId: string;
  retryCount: number;
}
export interface FirmwareAliveStatusResponse extends CommonResponse {
  result: {
    alive: boolean;
    marked: boolean;
  };
}

export interface GetFeaturesPopupListResponse extends CommonPageResponse {
  result: FeaturesPopupListData[];
}

export interface FeaturesPopupDetailResponse extends CommonResponse {
  result: FeaturesPopupListData;
}

// Firmware Package
export interface CreateFirmwarePackageRequest {
  version: string;
  recorderType: string;
  model: string;
  fileName: string;
  fileSize: number;
  checksum: string;
  releaseNote?: string;
  isActive: boolean;
  id?: string;
}

export interface FirmwarePackageCreateResult {
  version: string;
  recorderType: string;
  model: string;
  fileName: string;
  s3Key: string;
  fileSize: number;
  checksum: string;
  releaseNote?: string;
  uploadStatus: string;
  isActive: boolean;
}

export interface FirmwarePackageListResult extends FirmwarePackageCreateResult {
  id: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  presignedUrl: string;
}
export interface ReleaseNoteCreateResult {
  version: string;
  content: string;
  isActive: boolean;
  id?: string;
  createdAt: string;
  releasedAt: string;
  createdBy: string;
  createdEmail: string;
}

export interface FirmwarePackageListResponse extends CommonPageResponse {
  result: FirmwarePackageCreateResult[];
}

export interface CreateFirmwarePackageResponse extends CommonResponse {
  result: FirmwarePackageListResult;
}

export interface UploadStatusFirmwareRequest {
  fileSize?: number;
  checksum?: string;
}

export enum FIRMWARE_UPLOAD_STATUS {
  PRESIGNED = "PRESIGNED",
  UPLOADED = "UPLOADED",
  FAILED = "FAILED",
}

export interface FirmwarePackageUploadStatusResult {
  id: string;
  uploadStatus: FIRMWARE_UPLOAD_STATUS;
  fileSize: number;
  checksum: string;
  s3Key: string;
  verifiedAt?: string;
}

export interface FirmwarePackageUploadStatusResponse extends CommonResponse {
  result: FirmwarePackageUploadStatusResult;
}

export interface UpdateFirmwarePackageRequest {
  version?: string;
  recorderType?: string;
  model?: string;
  fileName?: string;
  fileSize?: number;
  checksum?: string;
  releaseNote?: string;
  isActive?: boolean;
}

export interface FirmwarePackageUpdateResult {
  id: string;
  version: string;
  recorderType: string;
  model: string;
  fileName: string;
  s3Key: string;
  fileSize: number;
  checksum: string;
  releaseNote?: string;
  uploadStatus: string;
  isActive: boolean;
  updatedAt: string;
  presignedUrl?: string;
}

export interface FirmwarePackageUpdateResponse extends CommonResponse {
  result: FirmwarePackageUpdateResult;
}

export interface FirmwarePackageDownloadUrlResult {
  id: string;
  version: string;
  fileName: string;
  s3Key: string;
  downloadUrl: string;
  expireAt: string;
}

export interface FirmwarePackageDownloadUrlResponse extends CommonResponse {
  result: FirmwarePackageDownloadUrlResult;
}

export interface FirmwarePackageDeleteResult {
  id: string;
  isActive: boolean;
  deletedAt?: string;
}

export interface FirmwarePackageDeleteResponse extends CommonResponse {
  result: FirmwarePackageDeleteResult;
}

// Recorder Merged System (isUpdate 필드 추가)
export interface RecorderMergedSystemItem {
  isUpdate: boolean;
  [key: string]: unknown;
}

// 8. Firmware Update Info (펌웨어 업데이트 팝업 정보)
export interface FirmwareUpdateInfoResult {
  recorderId: string;
  mergedSystemName: string;
  recorderType: string;
  displayType: string;
  cameraCount: number;
  currentVersion: string;
  currentReleaseNote: string | null;
  updateVersion: string | null;
  updateReleaseNote: string | null;
  upgradeStatus: string; // READY | PROGRESS 등
  autoUpgradeTime: string;
}

export interface FirmwareUpdateInfoResponse extends CommonResponse {
  result: FirmwareUpdateInfoResult;
}

// 9. Firmware Upgrade Request (펌웨어 업그레이드 요청)
export interface FirmwareUpgradeRequest {
  targetVersion: string;
}

export interface FirmwareUpgradeResponse extends CommonResponse {
  result: "ok";
}

// 10. Firmware Upgrade Progress (장치 업그레이드 진행 상태) - Request Body
export enum FIRMWARE_UPGRADE_STATUS {
  READY = "READY",
  INIT = "INIT",
  VERIFY = "VERIFY",
  START = "START",
  PROGRESS = "PROGRESS",
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
  COMPLETE = "COMPLETE",
}

export enum FIRMWARE_UPDATE_STEP {
  INTRO = "INTRO",
  UPDATE = "UPDATE",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}
